import { Token } from '@ui/config/token';
import { Fraction } from 'bi-fraction';

export const useMaxValue = (
  fromToken: Token,
  balance: Fraction | undefined,
) => {
  if (fromToken === Token.zkCRO) {
    const maxValue = balance?.sub(2);
    if (!maxValue || maxValue.lt(0)) {
      return Fraction.ZERO;
    }
    return maxValue;
  }

  return balance;
};
